import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

@Injectable({ providedIn: 'root' })
export class GeneralRemoteControllerService {


    constructor(
        private readonly _apiService: ApiService
    ) {

    }

    version() {
        return this._apiService.get<{ version: string }>('version')
    }
}
